import { render, staticRenderFns } from "./FormTagCategoriesModal.vue?vue&type=template&id=1adfea4e&scoped=true&"
import script from "./FormTagCategoriesModal.vue?vue&type=script&lang=js&"
export * from "./FormTagCategoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./FormTagCategoriesModal.vue?vue&type=style&index=0&id=1adfea4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adfea4e",
  null
  
)

export default component.exports